import { gql } from '@apollo/client';

export const QUERY_STATE = gql`
  query healthQuotePlans {
    healthQuote @client
    healthPlans @client
    selectedIntermediary @client
  }
`;

export const PIN_CODE_LOOKUP = gql`
  query pinCodeLookup($pincode: String) {
    pincodeInfo(filter: { pincode: $pincode }) {
      city
      district
      pinCode
      state
    }
  }
`;

export const GET_PRODUCT_DETAILS = gql`
  query getProductDetails(
    $productCode: String
    $startDate: String
    $agentID: String
  ) {
    productDetails(
      productCode: $productCode
      startDate: $startDate
      agentID: $agentID
    ) {
      applicableZones {
        code
        value
      }
      applicableTenures {
        code
        value
      }
      applicableCoverTypes {
        code
        value
      }
      applicableSumInsureds
      customApplicableSumInsureds {
        deductSumInsured
        sumInsured
      }
      applicableMemberTypes {
        label
        gender
        selectGender
        maxAllowed
      }
    }
    genderList {
      code
      value
    }
  }
`;

export const GET_PLAN_COVER_DETAILS = gql`
  query getPlanCoverDetails(
    $sumInsured: String
    $startDate: String
    $AgentID: String
    $productCode: String
    $members: [MembersInput]
  ) {
    planAndCovers(
      sumInsured: $sumInsured
      startDate: $startDate
      AgentID: $AgentID
      productCode: $productCode
      members: $members
    ) {
      name
      code
      covers {
        name
        index
      }
      packs {
        name
        index
        addOnCovers {
          name
          index
          selected
        }
      }
    }
  }
`;

export const CALCULATE_PREMIUM = gql`
  query calculatePremiumForQuote($input: CalculatePremiumQuote) {
    calculatePremiumSCPA(input: $input) {
      basePremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      
      breakup {
        relationship
        gender
        age
        premium
      }
      
    },
    
  }
`;

export const SAVE_QUOTE = gql`
  mutation saveQuote($input: QuoteInput) {
    saveQuote(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;

export const SEARCH_CUSTOMERS = gql`
  query searchCustomers(
    $customer_type: String
    $customer_number: StrictAlphaNumaric
    $customer_name: StrictAlphaNumaric
    $mobile: StrictNumber
  ) {
    _customer_meta(
      filter: {
        customer_type: $customer_type
        customer_name: $customer_name
        customer_number: $customer_number
        mobile: $mobile
      }
    ) {
      resultCount
      maxRow
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    customers(
      filter: {
        customer_type: $customer_type
        customer_number: $customer_number
        customer_name: $customer_name
        mobile: $mobile
      }
    ) {
      cust_type {
        code
        value
      }
      cust_number
      indv_detail {
        full_name
      }
      org_detail {
        org_name
      }
      contact {
        email
        mobile
      }
      permanent_address {
        location
      }
    }
  }
`;

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
  query searchCustomerByNumber(
    $customer_type: String
    $customer_number: String
  ) {
    customer(
      customer_type: $customer_type
      customer_number: $customer_number
    ) {
      cust_number
      cust_ref_number
      cust_type {
        code
        value
      }
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
        acc_holder
        micr_code
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      indv_detail {
        title {
          code
          value
        }
        first_name
        middle_name
        full_name
        surname
        date_of_birth
        id_proof_type {
          code
          value
        }
        id_proof_number
        pan_card_number
        nationality {
          code
          value
        }
        occupation {
          code
          value
        }
        gender {
          code
          value
        }
        marital_status {
          code
          value
        }
      }
      org_detail {
        org_name
        org_type {
          code
          value
        }
        reg_number
        tan_number
        gst_number
        contact_mob
        contact_name
        contact_email
      }
      contact {
        email
        mobile
      }
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const CUSTOMER_DROPDOWN_DETAILS = gql`
  query customerOrganisationDetails {
    organisationList {
      code
      value
    }
    salutationList {
      code
      value
    }
    businessTypeList {
      code
      value
    }
  }
`;

export const SEND_QUOTE_EMAIL_ALERT = gql`
  mutation sendQuoteEmail(
    $input: QuoteInput
    $email: String
    $quoteNumber: String
  ) {
    sendQuoteEmail(
      input: $input
      email: $email
      quoteNumber: $quoteNumber
    ) {
      message
    }
  }
`;

export const SEND_QUOTE_SMS_ALERT = gql`
  mutation sendQuoteSMS(
    $input: QuoteInput
    $mobile: String
    $quoteNumber: String
  ) {
    sendQuoteSMS(
      input: $input
      mobile: $mobile
      quoteNumber: $quoteNumber
    ) {
      message
    }
  }
`;

export const SEND_QUOTE_PDF = gql`
  mutation sendQuotePDF($input: QuoteInput, $quoteNumber: String) {
    sendQuotePDF(input: $input, quoteNumber: $quoteNumber) {
      base64Pdf
    }
  }
`;

export const Vehicle_Typelist = gql`
  query vehicle_type($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;